exports.status = false //true为正式，false为测试